import {useContext, useEffect, useState} from 'react';
import {apis} from '../../services/alm';
import PodcastSection from '../pages/library-section/PodcastSection';
import {AppContext} from '../../context/AppProvider';
import {constants} from '../../assets/constants/constants';
import useLibrarySeeAll from '../../hooks/useLibrarySeeAll';

const Podcast = () => {
  const [podcastId, setPodcastId] = useState<any>('');
  const {state, dispatch} = useContext(AppContext);
  const {addBookMark, deleteBookMark, bookMarkresponse} = useLibrarySeeAll();
  useEffect(() => {
    const catalogIds = async () => {
      if (state?.user && state?.catlogList?.length) {
        try {
          const obj: any = {};
          state?.catlogList?.forEach((res: any) => {
            if (res?.attributes?.name.trim() == constants.PODCAST) {
              obj[res?.attributes?.name.trim()] = res;
            }
          });
          setPodcastId(obj);         
          const responseById: any = await apis.fetchContentByCatalogId(obj.Podcast.id,"library");
          const finalResult:any = [];
          finalResult.push(responseById.data);
          let isTrue = responseById?.links?.next;
          while (isTrue) {
            const res: any = await apis.nextBaseUrl(isTrue);
            finalResult.push(res.data);
            isTrue = res?.links?.next ? res?.links?.next : false;
          }
          dispatch({type: 'LIBRARY_DATA', payload: {Podcast: finalResult.flat()}});
        } catch (error) {
          console.log('error', error);
        }
      }
    };
    catalogIds();
  }, [bookMarkresponse, state?.user,state?.catlogList]);
  
  return (
    <PodcastSection
      podcast={'isHome'}
      addBookMark={addBookMark}
      deleteBookMark={deleteBookMark}
      catalogId={podcastId?.Podcast}
    />
  );
};
export default Podcast;
